import { all, call, select, put } from 'redux-saga/effects';
import { accountsGet } from './account';
import { portfoliosGet } from './portfolios';
import { createQadraSaga } from './shared';
import {
  FINANCIAL_ADVISOR_DASHBOARD_GET,
  CLIENT_DASHBOARD_AS_ADVISOR_GET,
  ACCOUNT_TOTAL_WEALTH_CHART_GET,
  FINANCIAL_ADVISOR_INVITE_LINK_POST,
} from '../actions/types';
import { walletWithTransactionsGet } from './wallets';
import { selectAccountAsAdvisor } from '../selectors/accounts';
import { apiTotalWealthProfileSimulation } from '../api/client';
import { apiAdvisorInviteLinkPost } from '../api/advisor';
import { accountInvestmentObjectivesGet } from './investmentObjectives';

function* financialAdvisorDashboardGet(action) {
  const calls = [portfoliosGet, accountsGet];
  yield all(calls.map((c) => call(c, action)));
}

const watchFinancialAdvisorDashboardGet = createQadraSaga(financialAdvisorDashboardGet, {
  action: FINANCIAL_ADVISOR_DASHBOARD_GET._REQUEST,
});

function* financialAdvisorInviteLinkPost({ payload: { id } }) {
  const { invitationLink } = yield call(apiAdvisorInviteLinkPost, id);
  yield put({
    type: FINANCIAL_ADVISOR_INVITE_LINK_POST._SUCCESS,
    payload: { inviteLink: invitationLink?.encodedInvitationLink },
  });
}

const watchFinancialAdvisorInviteLinkPost = createQadraSaga(financialAdvisorInviteLinkPost, {
  action: FINANCIAL_ADVISOR_INVITE_LINK_POST._REQUEST,
  hideSpinner: true,
});

function* clientDashboardAsAdvisorGet(action) {
  const { accountId } = action.payload;
  const calls = [
    accountInvestmentObjectivesGet,
    // accountLifestyleCostsGet,
    // accountFinancialAssetsGet,
    // accountPortfolioProposalsGet,
    // accountPortfoliosGet,
    walletWithTransactionsGet,
  ];

  yield all(calls.map((c) => call(c, action)));

  const account = yield select(selectAccountAsAdvisor, accountId);
  const wallets = yield select((state) => state.wallets.items[accountId]);

  let sumOtherAssets = account.financialAssets.otherAssets;
  if (wallets && wallets[0]) {
    sumOtherAssets += wallets[0].amount;
  }

  const { chart } = yield call(apiTotalWealthProfileSimulation, {
    initialInvestment: account.investmentObjectives.initialInvestment,
    investmentPeriod: account.investmentObjectives.investmentPeriod,
    averageYearlyInvestment: account.investmentObjectives.averageYearlyInvestment,
    monthlySalary: account.financialAssets.monthlySalary,
    monthlyOtherIncome: account.financialAssets.monthlyOtherIncome,
    otherAssets: sumOtherAssets,
    otherFinancialInvestments: account.financialAssets.otherFinancialInvestments,
    monthlyCostOfLiving: account.lifestyleCosts.monthlyCostOfLiving,
    monthlyFixedExpenses: account.lifestyleCosts.monthlyFixedExpenses,
    mortgage: account.lifestyleCosts.mortgage,
    otherLiabilities: account.lifestyleCosts.otherLiabilities,
    strategyReturn: account.acceptedPortfolioProposal.kpis.return,
    strategyVolatility: account.acceptedPortfolioProposal.kpis.volatility,
  });

  yield put({
    type: ACCOUNT_TOTAL_WEALTH_CHART_GET._SUCCESS,
    payload: { chart, accountId: action.payload.accountId },
  });
}

const watchClientDashboardAsAdvisorGet = createQadraSaga(clientDashboardAsAdvisorGet, {
  action: CLIENT_DASHBOARD_AS_ADVISOR_GET._REQUEST,
});

export default [
  watchFinancialAdvisorDashboardGet,
  watchClientDashboardAsAdvisorGet,
  watchFinancialAdvisorInviteLinkPost,
];
